import { render, staticRenderFns } from "./customerCaseDetail.vue?vue&type=template&id=53aac84f"
import script from "./customerCaseDetail.vue?vue&type=script&lang=js"
export * from "./customerCaseDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports